import "../App.css";
import { Intro, Logos, Presentacion, Youtube } from "../components";

const Home = ({ is2022, is2024, is2026, showPresentacion }) => {
  const year = is2022 ? { is2022: true } : is2024 ? { is2024: true } : { is2026: true };
  return (
    <>
      {showPresentacion && <Presentacion />}
      <Intro {...year} />
      <Youtube />
      <Logos />
    </>
  );
};

export default Home;
